import { c as _c } from "react/compiler-runtime";
import { useQuery, useSubscription } from '@apollo/client/react';
import { useCurrentUser } from '@src/hooks/useCurrentUser';
import { gql } from '@src/lib/gql';
const CURRENT_USER_DIRECT_CHAT_UNREAD_COUNT = gql`
  query AdvisorsDirectChatUnreadCount {
    currentUser {
      id
      directChatThreadsUnreadCommentsCount
    }
  }
`;
const SCO_USER_DIRECT_CHAT_VIEWED = gql`
  subscription AdvisorsDirectChatViewed {
    scoUserDirectChatViewed {
      user {
        id
        directChatThreadsUnreadCommentsCount
      }
    }
  }
`;
type UnreadCountData = {
  currentUser?: {
    directChatThreadsUnreadCommentsCount?: number | null;
  } | null;
};

/**
 * Aggregate unread direct-chat count for the current user, kept live by the
 * `scoUserDirectChatViewed` subscription.
 *
 * Used by the Inbox nav badge (so unread stays visible from anywhere in
 * Advisors) and by the inbox itself to re-sort when a thread is read elsewhere.
 */
export const useDirectChatUnreadCount = () => {
  const $ = _c(10);
  const {
    currentUser
  } = useCurrentUser();
  const t0 = !currentUser?.userId;
  let t1;
  if ($[0] !== t0) {
    t1 = {
      ssr: false,
      skip: t0
    };
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const query = useQuery(CURRENT_USER_DIRECT_CHAT_UNREAD_COUNT, t1);
  const t2 = !currentUser?.userId;
  let t3;
  if ($[2] !== query) {
    t3 = () => {
      query.refetch();
    };
    $[2] = query;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t2 || $[5] !== t3) {
    t4 = {
      skip: t2,
      onData: t3
    };
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  useSubscription(SCO_USER_DIRECT_CHAT_VIEWED, t4);
  const t5 = query.data?.currentUser?.directChatThreadsUnreadCommentsCount ?? 0;
  let t6;
  if ($[7] !== query.refetch || $[8] !== t5) {
    t6 = {
      unreadCount: t5,
      refetch: query.refetch
    };
    $[7] = query.refetch;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
};